import createIcon from '../../createIcon';

/**
 * @component @name Label
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTcuMTMgNS44NEMxNi43NyA1LjMzIDE2LjE3IDUgMTUuNSA1TDQuNSA1LjAxQzMuNCA1LjAxIDIuNSA1LjkgMi41IDdWMTdDMi41IDE4LjEgMy40IDE4Ljk5IDQuNSAxOC45OUwxNS41IDE5QzE2LjE3IDE5IDE2Ljc3IDE4LjY3IDE3LjEzIDE4LjE2TDIxLjUgMTJMMTcuMTMgNS44NFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Label = createIcon('Label', [
  [
    'path',
    {
      d: 'M17.13 5.84C16.77 5.33 16.17 5 15.5 5L4.5 5.01C3.4 5.01 2.5 5.9 2.5 7V17C2.5 18.1 3.4 18.99 4.5 18.99L15.5 19C16.17 19 16.77 18.67 17.13 18.16L21.5 12L17.13 5.84Z',
      key: '5x4oat',
    },
  ],
]);

export default Label;
